import React from 'react'
import YKModal, { DialogProps } from '@yk-component/yk-dialog-next'
import { Root } from 'react-dom/client'
import Button from '../button'
import Icon from '../../component/icon'
import './index.less'

type TModal = {
  children:React.ReactNode,
  hiddenCloseIcon?:boolean,
  hiddenFooter?:boolean,
  footer?:React.ReactNode,
  onOk?:any,
  onCancel?:any,
  visible:any,
  style?: React.CSSProperties,
  onVisibleChange?: (val:any, item:any)=>void
}

const Modal = ({
  children,
  hiddenCloseIcon = false,
  hiddenFooter = false,
  footer = null,
  onOk,
  onCancel,
  onVisibleChange,
  ...otherProps
}:TModal & DialogProps) => {
  return <YKModal
    prefixClass="mn"
    closeIcon={!hiddenCloseIcon && <Icon type="m-guanbi" className="mnDialogCloseIconFont" />}
    footer={!hiddenFooter && <div className="mn-modal-confirm-footer">
      {
        footer || <span>
          <Button
            className="mn-modal-confirm-footer-btn"
            onClick={() => {
              onCancel()
            }}
          >取消</Button>
          <Button
            className="mn-modal-confirm-footer-btn ml8"
            type="primary"
            onClick={() => {
              onOk()
            }}
          >确定</Button>
        </span>
      }
    </div>}
    onVisibleChange={(val) => onVisibleChange?.(val.value, val)}
    {...otherProps}
  >
    {children}
  </YKModal>
}

Modal.show = async ({ title, content, footer, onOk, onCancel, okText, cancelText }:DialogProps) => {
  const dialog = await YKModal.show({
    prefixClass: 'mn',
    closeIcon: false,
    footer: false,
    content: <div className="mn-modal-confirm-body">
      {
      title && <div className="mn-modal-confirm-title">{title}</div>
    }
      <div className="mn-modal-confirm-content">{content}</div>
      <div className="mn-modal-confirm-footer">
        {
          footer || <span>
            <Button
              className="mn-modal-confirm-footer-btn"
              onClick={() => {
                onCancel()
                dialog.destroy()
              }}
            >{cancelText || '取消'}</Button>
            <Button
              className="mn-modal-confirm-footer-btn ml8"
              type="primary"
              onClick={() => {
                onOk()
                dialog.destroy()
              }}
            >{okText || '确定'} </Button>
          </span>
          }
      </div>
    </div>
  })
  return dialog
}

export const destroy = (container: HTMLElement, divRoot: Root) => {
  if (container && container.parentNode) {
    container.parentNode.removeChild(container)
  }
  divRoot.unmount()
}

export default Modal
